import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Card, CardContent, Button } from "@kmf/ui";
import bpjphEmblem from "@/assets/bpjph-emblem.png";

// 인도네시아 할랄 법령·표준 (영문 원안 병기)
const regulations = [
  { ko: "할랄제품보증에 관한 2014년 법률 제33호 (개정 포함)", en: "Law No. 33 of 2014 on Halal Product Assurance, as amended", href: "https://cmsbl.halal.go.id/uploads/2014_UU_Nomor_33_Tahun_2014_Jaminan_Produk_Halal_2209235c2a.pdf" },
  { ko: "할랄제품보증 시행에 관한 2024년 정부령(PP) 제42호", en: "Government Regulation (PP) No. 42 of 2024 on the Implementation of Halal Product Assurance", href: "https://cmsbl.halal.go.id/uploads/Salinan_PP_Nomor_42_Tahun_2024_tentang_Bidang_Penyelenggaraan_Jaminan_Produk_Halal_ce371e0e1e.pdf" },
  { ko: "할랄제품보증시스템(SJPH) 기준에 관한 2023년 BPJPH 청장 결정 제20호", en: "Decree of the Head of BPJPH No. 20 of 2023 on the Criteria of the Halal Product Assurance System (SJPH)", href: "https://cmsbl.halal.go.id/uploads/Kepkaban_No_20_Tahun_2023_Perubahan_SJPH_3_bca72daa00.pdf" },
  { ko: "2024년 종교부 장관 결정(KMA) 제944호 (식품·음료 제품 유형)", en: "Decree of the Minister of Religious Affairs (KMA) No. 944 of 2024 (food and beverage product types)", href: "https://cmsbl.halal.go.id/uploads/KMA_944_tahun_2024_ttg_Perubahan_atas_KMA_748_Tahun_2021_ttd_682f720fb6.pdf" },
  { ko: "할랄 인증 의무 대상 제품 유형에 관한 2021년 종교부 장관 결정(KMA) 제748호", en: "Decree of the Minister of Religious Affairs (KMA) No. 748 of 2021 on Types of Products Required to Be Halal-Certified", href: "https://cmsbl.halal.go.id/uploads/KMA_748_tahun_2021_search_Jenis_Produk_yg_Wajib_Bersertifikat_Halal_84a17323b7.pdf" },
  { ko: "할랄 인증 면제 원료(포지티브 리스트)에 관한 2021년 종교부 장관 결정(KMA) 제1360호", en: "Decree of the Minister of Religious Affairs (KMA) No. 1360 of 2021 on Materials Exempted from Halal Certification (positive list)", href: "https://cmsbl.halal.go.id/uploads/KMA_1360_tahun_2021_tentang_Bahan_yang_dikecualikan_dari_kewajiban_bersertifikat_Halal_5a41b7b4e1.pdf" },
  { ko: "할랄 인증 의무 면제 제품·원료에 관한 2026년 BPJPH 청장 결정 제301호", en: "Decree of the Head of the Halal Product Assurance Organizing Agency (BPJPH) No. 301 of 2026 concerning Products and Materials Exempted from the Obligation to Obtain Halal Certification", href: "https://jdih.halal.go.id/jdih/dokumen/9372bdd2-e762-47c0-9147-a646166b41fe" },
  { ko: "할랄 식품 일반 요건에 관한 SNI 99004:2021", en: "SNI 99004:2021 on General Requirements for Halal Food", href: "https://pesta.bsn.go.id/produk/detail/13452-990042021" },
  { ko: "할랄 경영시스템에 관한 SNI 99001:2016", en: "SNI 99001:2016 on Halal Management Systems", href: "https://pesta.bsn.go.id/produk/detail/10949-sni990012016" },
];

// 추가 기준: 인도네시아 울라마 협의회(MUI) 파트와, KMF 인증 범위별 (영문 원안 병기)
const fatwaGroups = [
  { scope: "식품", items: [
    { ko: "할랄 파트와 표준화에 관한 2003년 MUI 파트와 제4호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 4 of 2003 on Halal Fatwa Standardization", href: "https://fatwamui.com/storage/357/23.-Standarisasi-Fatwa-Halal.pdf" },
    { ko: "식품의 미생물·미생물 산물 사용에 관한 2010년 MUI 파트와 제1호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 1 of 2010 on the Use of Microbes and Microbial Products in Food Products", href: "https://mui.or.id/baca/fatwa/penggunaan-mikroba-dan-produk-mikrobial-dalam-produk-pangan" },
  ] },
  { scope: "음료", items: [
    { ko: "알코올·에탄올 함유 식품·음료에 관한 2018년 MUI 파트와 제10호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 10 of 2018 on Food and Beverage Products Containing Alcohol/Ethanol", href: "https://mui.or.id/baca/fatwa/produk-makanan-dan-minuman-yang-mengandung-alkohol-etanol" },
  ] },
  { scope: "의약품", items: [
    { ko: "의약품과 치료에 관한 2013년 MUI 파트와 제30호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 30 of 2013 on Medicines and Treatment", href: "https://fatwamui.com/storage/113/No.-30-Obat-dan-Pengobatan.pdf" },
    { ko: "의약품·백신의 인간 이배체 세포 사용에 관한 MUI 파트와 제001/MUNAS X/MUI/XI/2020호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 001/MUNAS X/MUI/XI/2020 on the Use of Human Diploid Cells for Drugs and Vaccines", href: "https://mui.or.id/baca/fatwa/penggunaan-human-diploid-cell-untuk-bahan-produksi-obat-dan-vaksin" },
  ] },
  { scope: "화장품", items: [
    { ko: "화장품의 할랄 기준과 사용에 관한 2013년 MUI 파트와 제26호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 26 of 2013 on Halal Standards of Cosmetic Products and Their Use", href: "https://mui.or.id/baca/fatwa/standar-kehalalan-produk-kosmetika-dan-penggunaannya" },
    { ko: "남성용 화장품의 금 입자 사용에 관한 2018년 MUI 파트와 제47호", en: "Fatwa of the Indonesian Council of Ulama (MUI) No. 47 of 2018 on the Use of Gold Particles in Cosmetics for Men", href: "https://mui.or.id/baca/fatwa/penggunaan-partikel-emas-dalam-produk-kosmetika-bagi-laki-laki" },
  ] },
  { scope: "화학제품", items: [
    { ko: "알코올의 율법적 판단에 관한 2009년 MUI 파트와 제11호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 11 of 2009 on the Law of Alcohol", href: "https://fatwamui.com/storage/361/29.-Hukum-Alkohol.pdf" },
    { ko: "유전공학과 그 산물에 관한 2013년 MUI 파트와 제35호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 35 of 2013 on Genetic Engineering and Its Products", href: "https://fatwamui.com/storage/377/No.-35-Rekayasa-Genetika-dan-Produknya.pdf" },
  ] },
  { scope: "전 범위 공통", items: [
    { ko: "실험실 검사 대상 제품·원료에 관한 2022년 MUI 파트와 제80호", en: "Fatwa of Majelis Ulama Indonesia (MUI) No. 80 of 2022 on Products and/or Materials to Be Tested in Laboratory", href: "https://mui.or.id/baca/fatwa/produk-danatau-bahan-yang-harus-dilakukan-uji-laboratorium" },
  ] },
];

export function BpjphPage() {
  useEffect(() => {
    document.title = "인도네시아 BPJPH - KMF 할랄위원회";
  }, []);

  return (
    <div className="public-page py-12 md:py-16">
      <Container>
        <div className="public-page-header">
          <p className="eyebrow">인정기관</p>
          <h1 className="text-3xl font-bold text-foreground md:text-4xl">인도네시아 BPJPH</h1>
          <p className="mt-4 text-lg text-muted-foreground">Badan Penyelenggara Jaminan Produk Halal (BPJPH)</p>
        </div>

        <Card className="public-panel mb-8">
          <CardContent className="p-6 md:p-8">
            <div className="recognition-profile">
              <img src={bpjphEmblem} alt="BPJPH 기관 로고" className="recognition-emblem" />
              <dl className="recognition-facts">
                <div><dt>기관</dt><dd>Badan Penyelenggara Jaminan Produk Halal (BPJPH), Republik Indonesia</dd></div>
                <div><dt>인증 기준</dt><dd>SJPH (할랄제품보증시스템)</dd></div>
                <div><dt>공식 사이트</dt><dd><a href="https://bpjph.halal.go.id/" target="_blank" rel="noopener noreferrer">bpjph.halal.go.id ↗</a></dd></div>
              </dl>
            </div>
          </CardContent>
        </Card>

        <Card id="indonesian-regulations" className="public-panel mb-8">
          <CardContent className="p-6 md:p-8">
            <h2 className="mb-4 text-xl font-semibold">인도네시아 할랄 법령·표준</h2>
            <h3 className="regulation-group">주요 기준</h3>
            <ol className="regulation-list">
              {regulations.map((item) => (
                <li key={item.en}>
                  <p><a href={item.href} target="_blank" rel="noopener noreferrer" className="regulation-link">{item.ko}<span aria-hidden="true"> ↗</span></a></p>
                  <p className="regulation-original" lang="en">{item.en}</p>
                </li>
              ))}
            </ol>
            <h3 className="regulation-group">추가 기준: 인도네시아 울라마 협의회(MUI) 파트와</h3>
            {fatwaGroups.map((group) => (
              <div key={group.scope} className="fatwa-scope">
                <h4 className="fatwa-scope-title">{group.scope}</h4>
                <ol className="regulation-list">
                  {group.items.map((item) => (
                    <li key={item.en}>
                      <p><a href={item.href} target="_blank" rel="noopener noreferrer" className="regulation-link">{item.ko}<span aria-hidden="true"> ↗</span></a></p>
                      <p className="regulation-original" lang="en">{item.en}</p>
                    </li>
                  ))}
                </ol>
              </div>
            ))}
          </CardContent>
        </Card>

        <div className="flex flex-wrap items-center gap-6">
          <Button asChild variant="outline">
            <a href="https://bpjph.halal.go.id/" target="_blank" rel="noopener noreferrer">BPJPH 공식 사이트 (새 창)</a>
          </Button>
          <Link to="/about" className="text-link">위원회 소개로 <span aria-hidden="true">→</span></Link>
        </div>
      </Container>
    </div>
  );
}
